import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { Maintenance } from "../model/maintenance";

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

    public maintenanceDate: string = '';
    public maintenanceTime: string = '';
    public maintenanceEndTime: string = '';

    constructor(private baseService: BaseService) {}


    public getMaintenanceData(): Observable<Maintenance> {
        return this.baseService.get('api/maintenance');
    }


   public setMaintenanceDate(date: string) {
    this.maintenanceDate = date;
  
  }

  public setMaintenanceTime(time: string) {
    this.maintenanceTime = time;
  
  }

  public setMaintenanceEndTime(time: string) {
    this.maintenanceEndTime = time;
  }

  public getMaintenanceDate() {
    return this.maintenanceDate;
  }

  public getMaintenanceTime() {
    return this.maintenanceTime;
  }

  public getMaintenanceEndTime() {
    return this.maintenanceEndTime;
  }

}